import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { PricingProfile } from "../../../types/models/PricingProfile";
import PriceListItem from "../../../../timber/components/price/PriceList/PriceListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: PricingProfile;
};

const PricingProfileTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'price');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="PricingProfile-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/Prices/list/view') &&
                    <Tab label={t`Prices`} value="price"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/Prices/list/view') &&
                <TabPanel value={tabValue} index="price" data-testid="Price-tab">
                    <PriceListItem pricingProfileId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default PricingProfileTabs;
